// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { DepositFragment } from '../../fragments/generated/deposit.fragment.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetLinkedInvoicesQueryVariables = Types.Exact<{
  depositId: Types.Scalars['Int']['input'];
}>;


export type GetLinkedInvoicesQueryResult = { __typename?: 'Query', getLinkedInvoices: Array<{ __typename?: 'InvoiceToDepositDTO', amount: number, depositId: number, invoiceId: number, deposit: { __typename?: 'DepositDTO', amount: number, block: string | null, date: LocalDate, depositInvoiceId: number | null, depositUseId: number | null, holderId: number | null, holderType: Types.InvoiceHolderTypeDto | null, id: number, ownerCorporateDataId: number | null, ownerId: number, paymentId: number | null, reservationId: number | null, username: string | null } }> };

export const GetLinkedInvoicesGql = gql`
    query GetLinkedInvoices($depositId: Int!) {
  getLinkedInvoices(depositId: $depositId) {
    amount
    depositId
    invoiceId
    deposit {
      ...Deposit
    }
  }
}
    ${DepositFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLinkedInvoicesInjectable extends Apollo.Query<GetLinkedInvoicesQueryResult, GetLinkedInvoicesQueryVariables> {
    override document = GetLinkedInvoicesGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */